import { createContext, Dispatch, SetStateAction } from 'react';

type TFilterableContext = {
  filter: PrepModeSectionSongsFilter;
  setFilter: Dispatch<SetStateAction<PrepModeSectionSongsFilter>>;
};

export const PrepModeSongsFilterableContext = createContext<TFilterableContext>(undefined!);
